import type { ClientModule } from '@/app/module';
import cards from './cards';
import combine from './combine';
import gamelab from './gamelab';
import games from './games';
import platform from './platform';
import players from './players';
import push from './push';
import sessions from './sessions';
import stats from './stats';
import studio from './studio';
import tournaments from './tournaments';

/**
 * The client module registry (frozen with the Foundation). Order here is the order init() runs
 * and the tie-break for equal `order` values. Adding a module is a change request.
 */
export const CLIENT_MODULES: readonly ClientModule[] = Object.freeze([
  platform,
  push,
  cards,
  players,
  games,
  stats,
  combine,
  tournaments,
  studio,
  gamelab,
  sessions,
]);
